import { useEffect, useState } from "react";
import PopupContent from "../popupContent";
import "./ProductTreeSelector.css";
import "./ProductBreadCrumb.css";
import { useTranslation } from "react-i18next";

interface Props {
    productGroup: any;
    selectedGroups: any[];
    isChecked?: boolean;
    onChange: any;
}

const ChildProductGroup = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'ProductGroupsTree' })
    const [selectedGroups, setSelectedGroups] = useState<any[]>([]);
    useEffect(() => {
        setSelectedGroups(props.selectedGroups);
    }, [props.selectedGroups.length]);
    let itemClassName = true
        ? `treeview-item-selectable`
        : `treeview-item`;

    if (props.productGroup.isRootForDecorative) {
        itemClassName += " rootDecorative";
    }

    if (props.productGroup.isRootForIndustry) {
        itemClassName += " rootIndustry";
    }

    const isChecked = selectedGroups.find(g => { return g === props.productGroup.id }) ? true : false;

    const handleChange = (e) => {
        props.onChange(props.productGroup.id, e.currentTarget.checked);
    }

    const label = t(`${props.productGroup.id}.name`) || props.productGroup.name;

    return (
        <>
            <ul className={`nested1`}>
                <li className="">
                    <a className="closed">
                        <span className="">
                            <input type="checkbox" checked={isChecked} onClick={handleChange}></input>
                            &nbsp;
                            <span
                                className={itemClassName}
                            >
                                {label}
                            </span>
                            {/* {productGroup.childGroups &&
                                productGroup.childGroups.length > 0 &&
                                productGroup.childGroups.map((childGroup: any) => {
                                    return renderGroup(childGroup, true);
                                })} */}
                        </span>
                    </a>
                </li>
            </ul>
        </>
    );
};

export default ChildProductGroup;
